<template>
	<span
		class="inline-flex justify-center items-center text-xs rounded-full"
		:class="{
			'bg-white border border-dj-grey-light text-dj-gray-dark': type == 'normal',
			'bg-dj-red border border-transparent text-white': type == 'red',
			'bg-dj-pink border border-transparent text-dj-red': type == 'pink',
			'bg-dj-gold border border-transparent text-white': type == 'gold',
			'bg-dj-blue/5 border border-transparent text-dj-gray-dark': type == 'grey',
			'bg-dj-cyan/10 border border-transparent text-dj-cyan': type == 'cyan',

			'h-dj-50 px-6 text-sm': size == 'big',
			'h-dj-40 px-5': size == 'normal',
			'h-dj-30 px-[0.6rem]': size == 'medium',
			'h-dj-24 px-3': size == 'small',

			'w-dj-50 px-0': circle && size == 'big',
			'w-dj-40 px-0': circle && size == 'normal',
			'w-dj-30 px-0': circle && size == 'medium',
			'w-dj-24 px-0': circle && size == 'small',
		}"
		v-bind="$attrs"
	>
		<span class="truncate"><slot></slot></span>
	</span>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
	name: "BaseTagPill",
	props: {
		type: {
			type: String,
			default: "normal",
			validator: (value: string) => {
				return ["normal", "red", "pink", "gold", "grey", "cyan"].includes(value);
			},
		},
		size: {
			type: String,
			default: "normal",
			validator: (value: string) => {
				return ["big", "normal", "medium", "small"].includes(value);
			},
		},
		circle: {
			type: Boolean,
			default: false,
		},
	},
});
</script>
